.clappr-watermark[data-watermark] {
  position: absolute;
  min-width: 70px;
  max-width: 200px;
  width: 12%;
  text-align: center;
  z-index: 10;
}

.clappr-watermark[data-watermark] a {
  outline: none;
  cursor: pointer;
}

.clappr-watermark[data-watermark] img {
  max-width: 100%;
}

.clappr-watermark[data-watermark-bottom-left] {
  bottom: 10px;
  left: 10px;
}

.clappr-watermark[data-watermark-bottom-right] {
  bottom: 10px;
  right: 42px;
}

.clappr-watermark[data-watermark-top-left] {
  top: 10px;
  left: 10px;
}

.clappr-watermark[data-watermark-top-right] {
  top: 10px;
  right: 37px;
}
